// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hardware-app textarea:focus {
  border: none !important;
}

.link-style {
  display: flex;
  color: rgb(189, 66, 87);
  text-decoration-line: none;
  &:hover {
    font-weight: 600;
  }
}

.hardware-assistant {
  display: flex;
  padding-top: 10px;
}

.new-tail {
  font-size: 10px;
  color: rgb(91, 124, 95);
  font-weight: 600;
  margin-left: 1px;
}

.icon-margin {
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".hardware-app textarea:focus {\n  border: none !important;\n}\n\n.link-style {\n  display: flex;\n  color: rgb(189, 66, 87);\n  text-decoration-line: none;\n  &:hover {\n    font-weight: 600;\n  }\n}\n\n.hardware-assistant {\n  display: flex;\n  padding-top: 10px;\n}\n\n.new-tail {\n  font-size: 10px;\n  color: rgb(91, 124, 95);\n  font-weight: 600;\n  margin-left: 1px;\n}\n\n.icon-margin {\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
